import store from "@frameworks/web/redux/store/index";
import { GETREGISTEREDDEVICEDETAILS, GETREGISTEREDDEVICEDETAILS_ERROR, GETREGISTEREDDEVICEDETAILS_HIDE_ERROR, GETREGISTEREDDEVICEDETAILS_START_LOADER, GETREGISTEREDDEVICEDETAILS_STOP_LOADER } from "../interface/IGetRegisteredDevice";
class GetRegisteredDeviceActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getRegisterdDeviceData(data) {
        this.dispatch({
            type: GETREGISTEREDDEVICEDETAILS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: GETREGISTEREDDEVICEDETAILS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: GETREGISTEREDDEVICEDETAILS_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: GETREGISTEREDDEVICEDETAILS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: GETREGISTEREDDEVICEDETAILS_STOP_LOADER,
        });
    }
}
export default GetRegisteredDeviceActions;
